import useRouter from 'hooks/useRouter';
import ChargeVehicleModelListView from '../../components/ChargeVehicleModelListView';

function ChargeVehicleModelListScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeVehicleBrandId = router.query?.chargeVehicleBrandId;

  return (
    <ChargeVehicleModelListView showFullUI={true} chargeVehicleBrandId={chargeVehicleBrandId} />
  );
}

export default ChargeVehicleModelListScreen;
